import {DatabaseOutlined, HomeOutlined, MobileOutlined, PhoneOutlined} from '@ant-design/icons';
import {Typography} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {PHONE_TYPES} from '@/components/PhoneNumberField/PhoneInput/constants';

const {Text} = Typography;

const iconsByType = {
  [PHONE_TYPES.HOME]: <HomeOutlined/>,
  [PHONE_TYPES.MOBILE]: <MobileOutlined/>,
  [PHONE_TYPES.WORK]: <DatabaseOutlined/>,
  [PHONE_TYPES.OTHER]: <PhoneOutlined/>
};

// eslint-disable-next-line react/prop-types
const WrapperCmp = ({useLink, phone, children, ...rest}) => {
  if (useLink)
    return <a href={`tel:${phone}`} {...rest}>
      {children}
    </a>;
  return <div {...rest}>{children}</div>;
};

const Phones = ({value, columns, useLink, showType}) => {
  const data = value ? (Array.isArray(value) ? (value?.filter((e) => !!e?.phone) || null) : [value]) : null;
  if (!data || !data.length) return '-';
  return (
    <div className={classNames('flex', {'flex-col': columns}, {'items-center': !columns})}>
      {data?.filter((e) => !!e?.phone)?.map(({type, phone}, index) => {
        return <WrapperCmp useLink={useLink} key={index} phone={phone}
          className={classNames('flex flex-row items-center', {'mr-2': !columns}, {'mb-2': columns && data?.length > 1 && index !== data?.length - 1})}>
          {showType && <div className={classNames('flex items-center', {'mr-2': showType})}>{iconsByType[type]}</div>}
          <Text className="font-normal">{phone}</Text>
        </WrapperCmp>;
      })}
    </div>
  );
};

export default memo(Phones);

Phones.propTypes = {
  useLink: PropTypes.bool,
  showType: PropTypes.bool,
  value: PropTypes.array,
  columns: PropTypes.bool,
  item: PropTypes.object,
};

Phones.defaultProps = {
  showType: true,
  useLink: true
};
